"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _DocSummary = _interopRequireDefault(require("./DocSummary"));

var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));

var _styles = require("@material-ui/core/styles");

var _format = _interopRequireDefault(require("date-fns/format"));

var styles = function styles(theme) {
  return {
    root: {
      flexGrow: 1,
      fontWeight: 500
    },
    docList: {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      justifyContent: 'center',
      maxHeight: 'auto'
    },
    '& h1': (0, _extends2.default)({}, theme.typography.h4, {
      color: theme.palette.text.secondary,
      fontWeight: theme.typography.fontWeightMedium,
      margin: '8px 0 4px'
    }),
    '& .description': (0, _extends2.default)({}, theme.typography.headline, {
      margin: '0 0 20px'
    }),
    '& h2': (0, _extends2.default)({}, theme.typography.h6, {
      color: theme.palette.text.secondary,
      margin: '16px 0 12px'
    }),
    '& h3': (0, _extends2.default)({}, theme.typography.headline, {
      color: theme.palette.text.secondary,
      margin: '16px 0 12px'
    }),
    '& h4': (0, _extends2.default)({}, theme.typography.h5, {
      color: theme.palette.text.secondary,
      margin: '12px 0 8px'
    }),
    control: {
      padding: 16
    }
  };
};

var DocListing =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(DocListing, _React$Component);

  function DocListing() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, DocListing);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(DocListing)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      spacing: '16'
    };
    return _this;
  }

  (0, _createClass2.default)(DocListing, [{
    key: "getDocList",
    value: function getDocList() {
      var docList = [];
      this.props.docEdges.forEach(function (docEdge) {
        docList.push({
          path: docEdge.node.fields.route,
          slug: docEdge.node.fields.slug,
          tags: docEdge.node.frontmatter.tags,
          category: docEdge.node.frontmatter.category,
          description: docEdge.node.frontmatter.description,
          title: docEdge.node.frontmatter.title,
          cover: docEdge.node.frontmatter.cover,
          formattedDate: (0, _format.default)(docEdge.node.frontmatter.rawDate, 'MMMM Do YYYY'),
          excerpt: docEdge.node.excerpt,
          timeToRead: docEdge.node.timeToRead
        });
      });
      return docList;
    }
  }, {
    key: "render",
    value: function render() {
      var classes = this.props.classes;
      var spacing = this.state.spacing;
      var docList = this.getDocList();
      return _react.default.createElement(_Grid.default, {
        container: true,
        className: classes.root,
        spacing: 16
      }, _react.default.createElement(_Grid.default, {
        item: true,
        xs: 12
      }, _react.default.createElement(_Grid.default, {
        container: true,
        className: classes.docList,
        justify: "center",
        spacing: Number(spacing)
      }, docList.map(function (doc) {
        return _react.default.createElement(_DocSummary.default, {
          key: doc.title,
          docInfo: doc
        });
      }))));
    }
  }]);
  return DocListing;
}(_react.default.Component);

var _default = (0, _styles.withStyles)(styles)(DocListing);

exports.default = _default;